<template>
  <div>
    <div>
      <!-- Gender Input -->
      <div class="col form-group mt-3">
        <label
          class="mb-1"
          :style="
            template.secondaryTheme
              ? 'color: white !important; margin-bottom:5px; font-weight: light !important;'
              : ''
          "
        >
          {{ translation.genderIdentity }}
        </label>

        <div
          class="w-100 form-group form-radio left-align"
          :class="template.secondaryTheme ? 'ml-2' : 'ml-4'"
        >
          <input
            id="masculino"
            :key="key"
            v-model="obj.gender"
            class="mt-2"
            :class="
              template.secondaryInput ? 'form-check-input-secondary-theme' : 'form-check-input'
            "
            type="radio"
            value="M"
            @change="key++"
          />

          <label
            for="masculino"
            class="mt-2 ml-1"
            :style="
              template.secondaryTheme
                ? 'color: white !important; margin-bottom:5px; font-weight: 100 !important; margin-bottom: 6px; padding-top: -10px;'
                : ''
            "
          >
            {{ translation.male }}
          </label>

          <br />

          <input
            id="feminino"
            :key="key"
            v-model="obj.gender"
            :class="
              template.secondaryInput ? 'form-check-input-secondary-theme' : 'form-check-input'
            "
            type="radio"
            value="F"
            @change="key++"
          />

          <label
            for="feminino"
            class="ml-1"
            :style="
              template.secondaryTheme
                ? 'color: white !important; margin-bottom:5px; font-weight: 100 !important; margin-bottom: 6px; padding-top: -10px;'
                : ''
            "
          >
            {{ translation.female }}
          </label>

          <br />

          <input
            id="outro"
            :key="key"
            v-model="obj.gender"
            :class="
              template.secondaryInput ? 'form-check-input-secondary-theme' : 'form-check-input'
            "
            type="radio"
            value="N"
            @change="key++"
          />

          <label
            for="outro"
            class="ml-1"
            :style="
              template.secondaryTheme
                ? 'color: white !important; margin-bottom:5px; font-weight: 100 !important; margin-bottom: 6px;'
                : ''
            "
          >
            {{ translation.other }}
          </label>
        </div>
      </div>

      <!-- Birth Date Input -->
      <div class="col form-group mt-3">
        <input
          v-model="obj.birthDate"
          v-mask="'##/##/####'"
          class="w-100"
          :class="template.secondaryTheme ? 'secondary-input-theme' : ' c-input'"
          :placeholder="translation.birthDate"
          @keyup.enter="validateFields"
        />
      </div>
    </div>
  </div>
</template>

<script>
/* State */
import { mapState, mapMutations } from 'vuex'

/* Helpers */
import { mask } from 'vue-the-mask'

export default {
  name: 'GenderAndBirthDate',
  props: {
    validate: Boolean,
  },
  mask: {
    ...mask,
    tokens: {
      ...mask.tokens,
      null: /./,
    },
  },
  data: () => ({
    obj: {},
    key: 0,
  }),
  computed: {
    ...mapState(['config', 'registrationObject', 'subdomain', 'template']),
    translation() {
      if (this.obj.passport) {
        return {
          genderIdentity: 'Gender Identity',
          male: 'Male',
          female: 'Female',
          other: 'Other',
          birthDate: 'Date of birth (dd/mm/yyyy)',
          alertGender: 'You must inform your gender.',
          alertBirthDate: 'You must provide your date of birth.',
          alertValidDate: 'Please enter a valid date of birth.',
          alertMinimumAgeToAccount: `Age requirement: ${this.config.minimumAgeToAccount} years or older.`,
        }
      }
      return {
        genderIdentity: 'Identidade de Gênero',
        male: 'Masculino',
        female: 'Feminino',
        other: 'Outro',
        birthDate: 'Data de nascimento (dd/mm/aaaa)',
        alertGender: 'É necessário informar seu gênero.',
        alertBirthDate: 'É necessário informar sua data de nascimento.',
        alertValidDate: 'Informe uma data de nascimento válida.',
        alertMinimumAgeToAccount: `Cadastro permitido apenas para maiores de ${this.config.minimumAgeToAccount}.`,
      }
    },
  },
  watch: {
    validate(newValue) {
      if (newValue) this.validateFields()
    },
  },
  mounted() {
    // Creates a deep copy of the object in the store
    this.obj = JSON.parse(JSON.stringify(this.registrationObject))

    if (!this.obj.gender) this.obj.gender = 'g'
  },
  methods: {
    ...mapMutations([
      'updateRegistrationObject',
      'clearRegistrationErrors',
      'addRegistrationError',
    ]),
    validateBirthDate(dateStr, clientMinimumAge = 0) {
      // First check for the pattern
      if (!/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateStr)) return false

      // Parse the date parts to integers
      let parts = dateStr.split('/')

      let day = parseInt(parts[0], 10)
      let month = parseInt(parts[1], 10)
      let year = parseInt(parts[2], 10)

      // Check the ranges of month and year
      if (year < 1000 || year > 3000 || month == 0 || month > 12) return false

      const monthLength = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

      // Adjust for leap years
      if (year % 400 === 0 || (year % 100 !== 0 && year % 4 === 0)) {
        monthLength[1] = 29
      }

      // Check the range of the day
      if (day <= 0 || day > monthLength[month - 1]) return false

      // Convert the input date to a Date object
      const inputDate = new Date(year, month - 1, day)
      const today = new Date()

      // Calculate the maximum birthdate (150 years ago)
      const maxBirthDate = new Date(today)
      maxBirthDate.setFullYear(today.getFullYear() - 150)

      // Calculate the minimum birthdate based on the client age configuration
      const minBirthDate = new Date(today)
      if (clientMinimumAge > 0) {
        minBirthDate.setFullYear(today.getFullYear() - clientMinimumAge)
      }

      // Validate that the input date is within the allowed range
      if (inputDate < maxBirthDate || inputDate > minBirthDate) {
        return false
      }

      return true
    },
    validateFields() {
      this.$emit('validating')

      this.clearRegistrationErrors()

      let hasErrors = false

      if (!this.obj.gender || this.obj.gender === 'g') {
        hasErrors = true

        this.addRegistrationError({
          msg: this.translation.alertGender,
        })
      }

      if (!this.obj.birthDate || this.obj.birthDate.length < 10) {
        hasErrors = true

        this.addRegistrationError({
          msg: this.translation.alertBirthDate,
        })
      }

      if (!this.validateBirthDate(this.obj.birthDate, this.config.minimumAgeToAccount)) {
        hasErrors = true
        if (this.config.minimumAgeToAccount != undefined) {
          this.addRegistrationError({
            msg: this.translation.alertMinimumAgeToAccount,
          })
        }
        this.addRegistrationError({
          msg: this.translation.alertValidDate,
        })
      }

      if (!hasErrors) {
        this.$store.commit('updateRegistrationObject', this.obj)

        this.$emit('next')
      }
    },
  },
}
</script>

<style scoped>
.form-check-input-secondary-theme {
  appearance: none;
  border-radius: 100%;
  height: 16px;
  width: 16px;
  border: 1px solid #fff;
  background-color: transparent;
  transition: all;
  transition-duration: 200ms;
  margin-top: 0px;
  margin-left: -19px;
  align-self: initial;
  float: left;
  cursor: pointer;
}

.form-check-input {
  appearance: none;
  border-radius: 100%;
  height: 16px;
  width: 16px;
  border: 1px solid #fff;
  background-color: transparent;
  transition: all;
  transition-duration: 200ms;
  margin-top: 0px;
  margin-right: 8px;
  align-self: initial;
  float: left;
  cursor: pointer;
}

.left-align {
  text-align: left;
}

.form-check-input:checked {
  background-color: var(--primary-color);
}

.form-check-input-secondary-theme:checked {
  background-color: #fff;
}

.form-check-input-secondary-theme:focus {
  outline: none;
}

.form-check-input:focus {
  outline: none;
}

.form-radio label {
  margin-bottom: 0.5;
}
</style>
